import { ReservationsService } from './../../../_services/reservations/reservations.service';
import { Subscription } from 'rxjs';
import { Table } from '../../../../_models/table';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
  Input,
  OnDestroy,
} from '@angular/core';
import { TableStatuses } from '../../../../_enums/table-statuses.enum';
import { differenceInHours, differenceInMinutes } from 'date-fns';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TableComponent implements OnInit, OnDestroy {
  @Input()
  table: Table;
  isChoosen: boolean;
  isAvailable: boolean;

  @ViewChild('tableDiv') tableDiv: ElementRef<HTMLDivElement>;
  isChoosenSub: Subscription;
  isAvailableSub: Subscription;
  isOccupiedSub: Subscription;
  tableStatus: TableStatuses;
  timeToReservation: string;
  isParkingNeeded: boolean;

  constructor(
    public changeRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private reservationsService: ReservationsService
  ) {}
  ngOnDestroy(): void {
    if (this.isChoosenSub) this.isChoosenSub.unsubscribe();
    if (this.isAvailableSub) this.isAvailableSub.unsubscribe();
  }

  chooseTable(): void {
    this.reservationsService.tableClicked(this.table);
  }

  positionTable(table: Table): void {
    this.renderer.setStyle(this.tableDiv.nativeElement, 'top', `${table.top}%`);
    this.renderer.setStyle(
      this.tableDiv.nativeElement,
      'left',
      `${table.left}%`
    );
    this.renderer.setStyle(
      this.tableDiv.nativeElement,
      'width',
      `${table.width}%`
    );
    this.renderer.setStyle(
      this.tableDiv.nativeElement,
      'height',
      `${table.height}%`
    );
    if (table.round) {
      this.renderer.setStyle(
        this.tableDiv.nativeElement,
        'border-radius',
        '50%'
      );
    }
    this.isChoosenSub = this.reservationsService.$choosenTables.subscribe(
      (choosenTables) => {
        this.isChoosen = choosenTables.includes(this.table);
        this.changeRef.detectChanges();
      }
    );
    this.isAvailableSub =
      this.reservationsService.$notAvailableTables.subscribe(
        (notAvailableTables) => {
          let notAvailableStatus = notAvailableTables.find(
            (table) => table.tableId === this.table.id
          );
          this.isAvailable = !notAvailableStatus;
          if (notAvailableStatus) {
            this.tableStatus = notAvailableStatus.status;
            this.isParkingNeeded = notAvailableStatus.parkingNeeded;
            this.timeToReservation = `${differenceInHours(
              notAvailableStatus.startDate,
              new Date()
            )}:${(
              differenceInMinutes(notAvailableStatus.startDate, new Date()) % 60
            )
              .toString()
              .padStart(2, '0')}`;
          } else {
            this.tableStatus = TableStatuses.AVAILABLE;
          }

          this.changeRef.detectChanges();
        }
      );
    this.changeRef.detectChanges();
  }

  ngOnInit(): void {}
}
